module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_9395_taupe.5fee1fec.jpg";